import React, { useState } from 'react';

export default function ReuploadRequestDialog({ label, busy, onSave, onClose }) {
  const [reason, setReason] = useState('');
  return <div style={{position:'fixed',inset:0,zIndex:10020,background:'#0f172aaa',display:'grid',placeItems:'center',padding:20}}>
    <section role="dialog" aria-modal="true" aria-labelledby="reupload-title" style={{background:'white',borderRadius:16,padding:24,width:'min(540px, 100%)'}}>
      <h2 id="reupload-title">Request replacement — {label}</h2>
      <form onSubmit={event=>{event.preventDefault(); if(reason.trim()) onSave(reason.trim());}}>
        <label htmlFor="reupload-reason">What must the worker correct or replace?</label>
        <textarea id="reupload-reason" autoFocus required maxLength={1000} value={reason} disabled={busy} onChange={event=>setReason(event.target.value)} style={{display:'block',width:'100%',minHeight:110,margin:'12px 0',boxSizing:'border-box'}} />
        <p>The worker will see this reason with the document.</p>
        <button type="submit" disabled={busy || !reason.trim()}>{busy?'Saving…':'Save reupload request'}</button>{' '}
        <button type="button" disabled={busy} onClick={onClose}>Cancel</button>
      </form>
    </section>
  </div>;
}
